export enum SnackBarStoreItemType {
  success = 'success',
  error = 'error',
}
